import * as React from "react";
import { Link } from "react-router-dom";
import { BrandLogo } from "@/components/brand/BrandLogo";

interface AuthLayoutProps {
  eyebrow: string;
  title: string;
  sub: string;
  children: React.ReactNode;
}

/**
 * Shared layout for the public auth surfaces (login / register /
 * forgot-password / reset-password). Wraps the form card in the same
 * blue-tinted gradient the landing pages use, so the marketing → app
 * handoff feels seamless.
 */
export function AuthLayout({ eyebrow, title, sub, children }: AuthLayoutProps) {
  return (
    <div className="brand-gradient-bg brand-radial-halo relative min-h-[100dvh] overflow-hidden">
      <div className="relative z-10 mx-auto flex w-full max-w-md flex-col items-center px-4 py-10 sm:py-16">
        <Link to="/" className="mb-8 flex items-center">
          <BrandLogo className="h-9 w-auto" />
        </Link>

        <span className="brand-pill-recommended mb-4">{eyebrow}</span>
        <h1 className="text-center font-display text-2xl font-bold tracking-tight sm:text-3xl">
          {title}
        </h1>
        <p className="mt-2 max-w-sm text-center text-sm text-muted-foreground">{sub}</p>

        <div className="mt-7 w-full">{children}</div>
      </div>
    </div>
  );
}
